import type React from "react";
import { useTranslation } from "react-i18next";
import type { BriefDetails } from "src/model/model";

interface HotspotDetailsProps {
  data: BriefDetails | Record<string, unknown>;
  mode: "plan" | "recap";
}

const ns = "pages.chat.interactionDetails";

/** Renderer for Hotspot image and Hotspot vidéo */
const HotspotDetails: React.FC<HotspotDetailsProps> = ({ data, mode }) => {
  const { t } = useTranslation();
  if (!data) return null;

  if (mode === "plan") {
    const bd = data as BriefDetails;
    if (!bd.expectedHotspotSubjects?.length) return null;
    return (
      <div className="text-[11px] text-gray-700">
        <span className="font-medium text-gray-500">{t(`${ns}.hotspotSubjects`)} : </span>
        {bd.expectedHotspotSubjects.join(", ")}
      </div>
    );
  }

  return null;
};

export default HotspotDetails;
